import React from "react";
import {useTranslation} from "react-i18next";
// local
import {Modal} from "components/Modal";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";

export const RftProposalCreateOfferModal = ({onSubmit, onClose}) => {
  const {t} = useTranslation();

  return (
    <Modal
      titleText="RFT_PROPOSAL_NOOFFER_MODAL_TITLE"
      noTitle
      customTitle
      noCenterContent
      boldTitle
      tightTitle
      rounded
      width="460"
      style={{marginTop: "15vh"}}
      onClose={onClose}
    >
      <div className="pa-8">
        <p className="__bold">{t("RFT_PROPOSAL_NOOFFER_MODAL_SUBTITLE")}</p>
        <span>{t("RFT_PROPOSAL_NOOFFER_MODAL_DESCRIPTION")}</span>

        <div className="df mt-8">
          <ButtonTransparent
            name="CANCEL"
            medium
            color="red"
            onClick={onClose}
            addClass="mr-2 mla"
          />
          <ButtonTransparent
            name="RFT_PROPOSAL_NOOFFER_MODAL_OKBUTTON"
            medium
            nowrap
            nonTransparent
            onClick={onSubmit}
          />
        </div>
      </div>
    </Modal>
  );
};
